import fetch from 'utils/fetch';

export function productImsiList(productId,productName,agent,psize,currentPage) {
    const data = {
        agent,
        psize,
        productId,
        productName,
        currentPage
    };
    return fetch({
        url: '/productImsiList',
        method: 'get',
        params:data
    });
}



// WEBPACK FOOTER //
// ./src/api/productImsi.js